define('adminPhrasesView',[
  'module',
  'jquery',
  'underscore',
  'app',
  'settings',
  'tableView',
  'adminPhrasesListRowToolsView',
  'adminPhrasesListHeaderToolsView',
  'adminPhrasesCreateEditView',
  'entities/phrases'
], function (
  Module,
  $,
  _,
  App,
  Settings,
  TableView,
  RowToolsView,
  HeaderToolsView,
  CreateEditView
) {
  'use strict';

  var dtFormatter = function (value) {
    if (!value) return '';
    var lang = Settings.get('lang') || 'en';

    // Backbone DynamicText model
    if (typeof value.getTextInLocale === 'function') {
      try { return value.getTextInLocale(lang) || ''; } catch (e) {}
    }

    // Backbone model — access via .get()
    if (typeof value.get === 'function') {
      var vals = value.get('values');
      if (vals) {
        var vKeys = Object.keys(vals);
        return vals[lang] || (vKeys.length > 0 ? vals[vKeys[0]] : '');
      }
    }

    // Plain object with values map (DynamicTextJson format)
    if (value.values) {
      var keys = Object.keys(value.values);
      return value.values[lang] || (keys.length > 0 ? value.values[keys[0]] : '');
    }

    // Plain object with dynamicTextLocalizeds array
    if (value.dynamicTextLocalizeds) {
      var dtls = value.dynamicTextLocalizeds;
      if (typeof dtls.toJSON === 'function') dtls = dtls.toJSON();
      var found = _.find(dtls, function (dtl) {
        return dtl.locale === lang || (dtl.locale && dtl.locale.toString && dtl.locale.toString() === lang);
      });
      return found ? (found.stdtext || '') : '';
    }

    return '';
  };

  Module.exports = TableView.extend({
    className: 'admin-phrases-list-view ' + TableView.prototype.className,
    pageMode: 'pagination',
    pageSize: 20,
    header: true,

    setFields: function () {
      return [{
        name: 'Code',
        label: _.i18n('phrases.code'),
        className: 'code',
        bind: 'code'
      }, {
        name: 'InternalName',
        label: _.i18n('phrases.internalName'),
        className: 'internal-name',
        bind: 'internalName',
        formatter: dtFormatter
      }, {
        name: 'EmailText',
        label: _.i18n('phrases.emailText'),
        className: 'email-text',
        bind: 'emailText',
        formatter: dtFormatter
      }, {
        name: 'ProofsheetText',
        label: _.i18n('phrases.proofsheetText'),
        className: 'proofsheet-text',
        bind: 'proofsheetText',
        formatter: dtFormatter
      }, {
        name: 'Buttons',
        className: 'buttons',
        view: RowToolsView,
        headerView: HeaderToolsView
      }];
    },

    fetch: function (first, pageSize) {
      var defer = $.Deferred();

      if (!first) first = 0;
      if (pageSize) this.pageSize = pageSize;

      var params = {};
      params.pageSize = this.pageSize;
      params.first = first;

      if (this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('phrases:get-url', params),
        success: _.bind(function (items) {
          var models = [];
          _.each(items, _.bind(function (item) {
            models.push(App.request('phrases:model', item));
          }, this));
          defer.resolve(models);
        }, this),
        error: function () {
          defer.resolve([]);
        }
      });

      return defer.promise();
    },

    fetchCount: function () {
      var defer = $.Deferred();

      if (this.fetchCountRequest)
        this.fetchCountRequest.abort();

      this.fetchCountRequest = $.ajax({
        url: App.request('phrases:row-count-url'),
        success: function (count) {
          defer.resolve(count);
        },
        error: function () {
          defer.resolve(0);
        }
      });

      return defer.promise();
    },

    onRowClick: function (view) {
      var m = App.request('phrases:model', {secId: view.model.get('secId')});
      m.fetch().done(_.bind(function () {
        var createEditView = new CreateEditView({
          phraseModel: m,
          newItem: false
        });
        createEditView.show({
          title: _.i18n('phrases.edit')
        });
        createEditView.listenTo(createEditView, 'saved', _.bind(function () {
          this.bodyView.fetch();
        }, this));
      }, this));
    }
  });
});

